import { useRef } from 'react';

import { DevTools } from 'jotai-devtools';

import { useFormyContext } from '../hooks/useFormyContext';
import { FormContextProvider } from '../provider/provider';
import { FormyProvider } from '../types/form';

/**
 * Provides a Jotai DevTools instance for the form.
 */
const FormJotaiDevTools = () => {
  const { store } = useFormyContext();
  return <DevTools store={store} />;
};

const FromProviderAccess = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[] | ((props: FormyProvider) => React.ReactNode);
}) => {
  const { store, formScrollableRef } = useFormyContext();
  return typeof children === 'function' ? children({ store, formScrollableRef }) : children;
};

/**
 * A FormProvider components
 *
 * Also is a wrapper that provides a Jotai DevTools instance for the form.
 */
const FormProvider = (props: {
  children: React.ReactNode | React.ReactNode[] | ((props: FormyProvider) => React.ReactNode);
}) => {
  const formScrollableRef = useRef<HTMLDivElement>(null);

  return (
    <FormContextProvider formScrollableRef={formScrollableRef}>
      <FromProviderAccess {...props} />
      <FormJotaiDevTools />
    </FormContextProvider>
  );
};

export { FormProvider };
